// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".main {\n  cursor: pointer;\n  border: 1px solid #babbc4;\n  border-radius: 6px;\n  padding: 16px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 16px;\n}\n.main ion-checkbox {\n  --size: 24px;\n}\n\n.main.error {\n  border: 2px solid red;\n}\n.main.error ion-checkbox {\n  --border-color: red;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
